import { render, staticRenderFns } from "./WotSnackbar.vue?vue&type=template&id=4ec1987e"
import script from "./WotSnackbar.vue?vue&type=script&lang=js"
export * from "./WotSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports